import { useParams } from 'react-router-dom';
import { useEntityUrl } from 'framework/routing';
import { useEmployeeUrl } from 'domain/shared/employee';

export const useEmployeeAssignmentUrl = () => {
  const { getSingleEntityUrl } = useEmployeeUrl();
  const baseUrls = useEntityUrl({ baseLink: `${getSingleEntityUrl()}/assignments` });

  return {
    ...baseUrls,
    getCopyEntityUrl: (id?: string) => `${baseUrls.getSingleEntityUrl(id)}/copy`,
    getListUrl: (id?: any) => `${getSingleEntityUrl(id)}/assignments`,
  };
};

export const useEmployeeAssignmentId = () => useParams<Dictionary<string>>().assignmentId;
